export class Contacto {

    constructor(
        public id: number = null,
        public name: string = "",
        public email: string = "",
        public phone: string = "",
        public mobilePhone: string = "",
        public locationId: number = null,
        public isQuarter: number = 0
    ) {}
}